// extracted by mini-css-extract-plugin
module.exports = {"content":"layout_content__6bdYY","landing-sidebar":"layout_landing-sidebar__EUC8Y","general-sidebar":"layout_general-sidebar__KOftp"};